export type PermissionTuple = { type: string; method: string; route: string };

/** Same encoding as the API's `assertCallerCanGrantPermissions`. */
export function permissionTupleKey(perm: PermissionTuple): string {
  return `${perm.type}|${perm.method}|${perm.route}`;
}

/**
 * A role is grantable iff every tuple on it exists on the caller.
 * `null` keys means unrestricted (super-tenant).
 */
export function isGrantablePermissionSet(
  permissions: PermissionTuple[] | undefined,
  callerTupleKeys: ReadonlySet<string> | null,
): boolean {
  if (callerTupleKeys === null) return true;
  return (permissions ?? []).every((perm) => callerTupleKeys.has(permissionTupleKey(perm)));
}

export function filterGrantableByPermissions<T extends { permissions?: PermissionTuple[] }>(
  items: T[],
  callerTupleKeys: ReadonlySet<string> | null,
): T[] {
  if (callerTupleKeys === null) return items;
  return items.filter((item) => isGrantablePermissionSet(item.permissions, callerTupleKeys));
}
